import type { InterestPartyChangeDirection as InterestPartyChangeDirectionType } from "../model/registrationEnums";
import {
  resetLeavingPartyEligibility,
  syncChangeEnteringPartyEligibility,
  syncLeavingPartyFields,
  clearLeavingPartyFields,
  type ChangePartyEligibilityRow,
} from "../eligibility/participantEligibilityRules";

export type { ChangePartyEligibilityRow };

export const clearChangePartyDirectionsWhenNotBegge = <
  T extends ChangePartyEligibilityRow,
>(
  parties: T[],
  changeKind: string,
  beggeKind: string,
): T[] | null => {
  if (changeKind === beggeKind || !parties.some((party) => party.direction)) {
    return null;
  }

  return parties.map((party) => ({ ...party, direction: "" }));
};

export const syncChangePartyEligibilityRow = <
  T extends ChangePartyEligibilityRow,
>(
  party: T,
  isEnters: boolean,
  syncEntering: (row: T) => T = syncChangeEnteringPartyEligibility,
): T => {
  if (!isEnters) {
    return syncLeavingPartyFields(resetLeavingPartyEligibility(party));
  }

  return syncEntering(clearLeavingPartyFields(party));
};

export const syncChangePartyEligibilityRows = <
  T extends ChangePartyEligibilityRow,
>(
  parties: T[],
  changeKind: string,
  isEnters: (
    changeKind: string,
    direction: InterestPartyChangeDirectionType,
  ) => boolean,
  syncEntering: (row: T) => T = syncChangeEnteringPartyEligibility,
): T[] =>
  parties.map((party) =>
    syncChangePartyEligibilityRow(
      party,
      isEnters(changeKind, party.direction as InterestPartyChangeDirectionType),
      syncEntering,
    ),
  );

export const changePartyRowChanged = <T>(before: T, after: T): boolean =>
  JSON.stringify(before) !== JSON.stringify(after);
